import script from "./ProfileSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSkills.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSkills.vue?vue&type=style&index=0&id=32296337&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32296337"]])

export default __exports__